"use client";
import { LazoPaths } from "@/enums/LazoPaths";
import { LAZO_USER_ROLES } from "@/types/LazoUserRoles";
import { CreateNewFolder as CreateNewFolderIcon, People as PeopleIcon } from "@mui/icons-material";
import MonitorOutlinedIcon from "@mui/icons-material/MonitorOutlined";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import User from "../external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import CommandAction from "../external/ensolvers-core-frontend-mui-v5/types/CommandAction";
import CommandActionSection from "../external/ensolvers-core-frontend-mui-v5/types/CommandActionSection";
import { LazoRoutes, lazoRoutesSpecification } from "../types/BaseProjectRoutes";
import { UserRole } from "../types/UserRole";

interface ItemType {
  [key: string]: JSX.Element;
}

interface PathToLandingPage {
  path: string;
  role: string;
}

export const STATIC_ICONS: ItemType = {
  userIcon: <PeopleIcon />,
  projectIcon: <CreateNewFolderIcon />,
  todoListIcon: <MoreTimeIcon />,
};

/**
 * Configure sections and tabs to be displayed in the sidebar (filtered by role)
 */
export const sections: CommandActionSection[] = [
  {
    key: "userManagement",
    label: "Users",
    icon: <PeopleIcon />,
    items: [
      {
        key: "userManagementTab",
        iconKey: "userIcon",
        actionPath: lazoRoutesSpecification[LazoRoutes.USER_MANAGEMENT].buildRoute(),
        label: "Users",
        tooltip: "",
        roles: [UserRole.ADMIN],
      },
    ],
  },
  {
    key: "sampleSection",
    label: "Sample Section",
    icon: <MonitorOutlinedIcon />,
    items: [
      {
        key: "chartsMockTab",
        iconKey: "projectIcon",
        actionPath: lazoRoutesSpecification[LazoRoutes.DASHBOARD].buildRoute(),
        label: "Charts Mock",
        tooltip: "",
        roles: [UserRole.ADMIN],
      },
    ],
  },
];

export const getSections = (user: User) => {
  let userSections = sections.reduce((prev: CommandActionSection[], section) => {
    let routesActions: CommandAction[] = [];
    section.items.forEach((route) => {
      let isRoleIncluded: boolean = false;
      user.userRoles.forEach((userRol) => {
        route.roles.includes(userRol.name) && (isRoleIncluded = true);
      });

      isRoleIncluded && routesActions.push(route);
    });
    if (routesActions.length > 0) {
      prev.push({
        key: section.key,
        label: section.label,
        icon: section.icon,
        items: routesActions,
      });
    }
    return prev;
  }, []);

  return userSections;
};

/**
 * Configure default/init page for each role
 */
export const defaultLandingPages: PathToLandingPage[] = [
  {
    role: LAZO_USER_ROLES.LAZO_PORTAL_EMPLOYEE,
    path: LazoPaths.PORTAL_CUSTOMERS,
  },
  {
    role: LAZO_USER_ROLES.LAZO_ONE,
    path: LazoPaths.MY_COMPANIES,
  },
  {
    role: LAZO_USER_ROLES.COMPANY_USER_ADMIN,
    path: LazoPaths.MY_COMPANIES,
  },
  {
    role: LAZO_USER_ROLES.COMPANY_USER_VIEWER,
    path: LazoPaths.MY_COMPANIES,
  },
  {
    role: LAZO_USER_ROLES.COMPANY_USER_STANDARD,
    path: LazoPaths.MY_COMPANIES,
  },
];

export const getLandingPageByUser = (user: User): string | undefined => {
  for (const item of defaultLandingPages) {
    if (user.userRoles.some((role) => role.name === item.role)) {
      return item.path;
    }
  }
  return undefined;
};
